import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly4D2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4D/7.webp`;


  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                   Topic: Be the change you wish to see in the world
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class:- 4D      Date: 10 to 12 August 2026.
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
The enthusiastic students of Class 4D presented an inspiring assembly on the theme ‘Be the change
you wish to see in the world’ from Monday to Wednesday, 10 to 12 August 2026. The assembly began
with a meaningful thought for the Day, followed by a brief introduction about Father of the Nation –
Mahatma Gandhi and highlighted the importance of his Core values- <strong>Truth, Peace, Kindness and
Fairness </strong>for strong society.  
<br></br>
   A beautiful song- DE DI HUMHE AZADI was presented by the entire class, showcasing excellent
coordination, balance and discipline.
        <br></br>
        The assembly concluded with an inspiring speech on father of the Nation - Mahatma Gandhi
encouraging everyone to embrace his core values to see the change in the world.
  <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
    The famous phrase ‘Be the change you wish to see in the world’ is a popular
phrase of Mahatma Gandhi’s philosophy on personal responsibility.
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 4C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly4D2026;
